export default __webpack_public_path__ + "static/carousel-avecFolie-b67f0bf1a4839a631d593b7ae769f003.png";